import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';

import {
  Heading,
  SingleInput,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveName',
  setup(__props) {

const updateData = inject('updateData', (key: string, name: string) => ({
  key,
  name
}));

const objectiveName = ref('');

const isDisabled = computed(() => {
  return objectiveName.value.trim() === '';
});

function clearName() {
  objectiveName.value = '';
}

function handleUpdateName() {
  if (isDisabled.value) return;

  updateData('objectiveName', objectiveName.value);
}

return { __sfc: true,updateData, objectiveName, isDisabled, clearName, handleUpdateName, Heading, SingleInput, ButtonContainer, ButtonPrimary }
}

})